/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import T from 'i18n-react';
import type { NextPage, NextPageContext } from 'next';
import type { ParsedUrlQuery } from 'querystring';

import MetaTags from 'Components/MetaTags/MetaTags';
import PageComposer from 'Components/PageComposer/PageComposer';
import SignIn from 'Components/SignIn/SignIn';
import texts from 'Components/texts.json';
import { PAGE_SLUGS } from 'Utilities/consts';
import type { GetInitialPropsMiddlewareContext } from 'Utilities/getInitialPropsMiddlewares/getInitialPropsMiddlewares.types';
import { unauthorisedOnly } from 'Utilities/getInitialPropsMiddlewares/unauthorisedOnly/unauthorisedOnly';
import { createMiddlewarePipeline } from 'Utilities/helpers/middlewarePipeline/middlewarePipeline';

T.setTexts(texts);

type SigninPageProps = {
	asPath?: string;
	query: ParsedUrlQuery;
};

const SigninPage: NextPage<SigninPageProps> = ({ asPath, query }) => {
	return (
		<>
			<MetaTags
				// @ts-ignore
				includeCanonicalTag
				description={T.translate('metaTags.pages.signIn.description')}
				ogTitle={T.translate('metaTags.pages.signIn.title')}
				title={T.translate('metaTags.pages.signIn.title')}
			/>

			<PageComposer pageSlug={PAGE_SLUGS.SIGN_IN}>
				<SignIn asPath={asPath} query={query} />
			</PageComposer>
		</>
	);
};

export const signInGetInitialProps = async (context: NextPageContext): Promise<SigninPageProps> => {
	const { asPath, query } = context;

	type MiddlewarePipelineContext = GetInitialPropsMiddlewareContext<typeof context, SigninPageProps>;

	const middlewarePipeline = createMiddlewarePipeline<MiddlewarePipelineContext>(unauthorisedOnly);

	const getInitialPropsMiddlewareContext: MiddlewarePipelineContext = {
		nextContext: context,
		returnValue: { asPath, query },
	};

	await middlewarePipeline.run(getInitialPropsMiddlewareContext);

	return getInitialPropsMiddlewareContext.returnValue;
};

SigninPage.getInitialProps = signInGetInitialProps;

export default SigninPage;
